import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import GoogleAuthButton from "@/components/GoogleAuthButton";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/esafc", label: "ESAFC" },
  { to: "/news", label: "News" },
  { to: "/get-involved", label: "Get Involved" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur bg-paper/90 border-b border-ink/10">
      <div className="max-w-[1140px] mx-auto px-6 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 font-bold no-underline text-ink" data-testid="nav-logo">
          <LogoMark size={40} />
          <span className="font-display text-xl leading-none">
            HOFA
            <small className="block font-sans text-[10.5px] font-semibold tracking-[0.12em] uppercase text-palm mt-0.5">
              Hope For All Organizations
            </small>
          </span>
        </Link>

        <nav aria-label="Main" className="hidden md:block">
          <ul className="flex gap-8 list-none m-0 p-0">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) =>
                    `no-underline font-semibold text-[15px] py-1.5 border-b-2 transition-colors ${
                      isActive ? "border-mango text-ink" : "border-transparent text-ink hover:border-mango"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <Link
          to="/get-involved"
          data-testid="nav-support-btn"
          className="hidden md:inline-block bg-mango text-palm-deep font-bold rounded-full px-5 py-2.5 text-[14.5px] hover:shadow-lg hover:-translate-y-0.5 transition no-underline"
        >
          Support HOFA
        </Link>

        <div className="hidden md:block">
          <GoogleAuthButton />
        </div>

        <button
          className="md:hidden text-ink"
          aria-label="Menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-ink/10 bg-paper">
          <ul className="flex flex-col px-6 py-3">
            {links.map((l) => (
              <li key={l.to} className="py-2">
                <NavLink
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="no-underline font-semibold text-ink"
                  data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li className="py-3">
              <Link
                to="/get-involved"
                onClick={() => setOpen(false)}
                className="inline-block bg-mango text-palm-deep font-bold rounded-full px-5 py-2.5 no-underline"
                data-testid="nav-mobile-support-btn"
              >
                Support HOFA
              </Link>
            </li>
            <li className="pt-2 border-t border-ink/10 mt-2">
              <GoogleAuthButton compact />
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
